<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="24" :sm="24" :lg="16">
      <el-button type="normal" @click.prevent="goBack" class="ml-20"><i class="el-icon-d-arrow-left"> 回上頁</i>
      </el-button>
    </el-col>
    <el-col :xs="24" :sm="24" :lg="8" style="text-align: right">
      <el-button v-if="basicForm.status === 'draft'" type="warning" @click.prevent="handleDraft">暫存 <i
          class="el-icon-s-claim"></i></el-button>
      <el-button v-if="basicForm.status === 'draft' || basicForm.status === 'reject'" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
          class="el-icon-s-claim"></i></el-button>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->

    <!--    基本資料-->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
            <!--            <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
          </div>
          <div>
            <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="100px">
              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="填單人" prop="userObj.username" >
                    <el-input :disabled="true" readonly v-model="basicForm.userObj.username"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題" prop="title">
                    <el-input v-model="basicForm.title" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期" prop="startDate" >
                    <el-date-picker type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>

    <!--    出勤資料-->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>出勤資料</span>
          </div>
          <div>
            <el-form :model="basicForm"
                     :rules="visitRules"
                     ref="visitDataForm"
                     label-width="100px">
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="出勤前工作" prop="preCheckTree">
                    <el-tree
                        :data="preCheckOption"
                        show-checkbox
                        node-key="value"
                        ref="tree"
                        :props="props"
                        :default-checked-keys="precheckListOption">
                    </el-tree>
                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="出勤路線" prop="visitRoute">
                    <el-input type="textarea" rows="5" v-model="basicForm.visitRoute"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->

    <!--    客戶拜訪資料-->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>客戶拜訪資料</span>
            <el-button v-if="basicForm.status === 'draft'" style="float: right; padding: 5px 12px" 　type="primary"
                       @click.prevent="handleAdd" class="mr-20">新增拜訪紀錄 <i class="el-icon-s-claim"></i></el-button>
          </div>
          <div>
            <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
              <el-table-column label="客戶" prop="customer.name">
              </el-table-column>
              <el-table-column label="抵達時間" prop="arrivalTime">
              </el-table-column>
              <el-table-column label="送貨內容">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.deliveryContent }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="服務內容">
                <template slot-scope="scope">
                  <el-tag type="success">{{ scope.row.serviceContent }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="收款">
                <template slot-scope="scope">
                  <el-tag type="warning">{{ scope.row.paymentReceive }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="紀錄/回饋" prop="notes">
              </el-table-column>
              <el-table-column label="附件" type="expand">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <ol>
                      <li v-for="f in scope.row.fileListDisplay" :key="f.id">
                        ({{f.fileNote}})<a :href="displayAvatar(f.fileRepo.uuid)">{{f.fileRepo.name}}</a>
                      </li>
                    </ol>
                  </el-form>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="200" v-if="basicForm.status === 'draft'">
                <template slot-scope="scope">
                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="handleDelete(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference">刪除 <i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>

    <!--    簽核紀錄-->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>
            <el-table :data="historyTableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
              <el-table-column label="時間" prop="updatedAt">
                <template slot-scope="scope">
                  {{ scope.row.updatedAt | fmtDateTime }}
                </template>
              </el-table-column>
              <el-table-column label="簽核人" prop="signerObj.username"></el-table-column>
              <el-table-column label="結果" prop="signResult">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="備註" prop="notes">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="填寫拜訪資訊"
               :visible.sync="dialogFormVisible"
               :width="dw"
               @close="closeDialog">

      <el-form :model="form" ref="visitForm" label-width="100px" :rules="visitFormRules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="客戶" prop="custId">
              <el-select
                  v-model="form.custId"
                  :multiple="false"
                  filterable
                  placeholder="輸入客戶名稱"
                  no-data-text="無資料">
                <el-option
                    v-for="c in options"
                    :key="c.id"
                    :label="`${c.name}-${c.company}`"
                    :value="c.id"
                    >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="抵達時間" prop="arrivalTime">
              <el-time-picker
                  v-model="form.arrivalTime"
                  selectableRange="['08:00' - '20:00']"
                  placeholder="選擇時間"
                  format='HH:mm'
                  value-format="HH:mm">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="送貨內容" prop="deliveryContentChecked"
                          :rules="{ required: true, message: '請勾選資料', trigger: 'change' }">
              <el-checkbox-group v-model="form.deliveryContentChecked">
                <el-checkbox v-for="opt in deliveryContentOptions" :key="opt" :label="opt"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="服務內容" prop="serviceContentChecked"
                          :rules="{ required: true, message: '請勾選資料', trigger: 'change' }">
              <el-checkbox-group v-model="form.serviceContentChecked">
                <el-checkbox v-for="opt in serviceContentOptions" :key="opt" :label="opt"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="收款" prop="paymentReceiveChecked"
                          :rules="{ required: true, message: '請勾選資料', trigger: 'change' }">
              <el-checkbox-group v-model="form.paymentReceiveChecked">
                <el-checkbox v-for="opt in paymentReceiveOptions" :key="opt" :label="opt"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="客戶交流與客戶回饋紀錄" prop="customerRecord">
              <el-input type="textarea" v-model="form.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row v-for="(btn, i) in btnCount" :key="i">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove"
                  :file-list="fileList">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField()">新增上傳</el-button>
          </el-col>
        </el-row>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCustomerVisit('visitForm')">確 定</el-button>
      </div>
    </el-dialog>
  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";

export default {
  name: "TodoDetailCustMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let treeCheck = (rule, value, callback) => {
      let selectedIds = this.$refs.tree.getCheckedKeys();

      if (!selectedIds || selectedIds.length === 0) {
        callback(new Error('請確認出勤前工作'))
      } else {
        callback()
      }
    }

    return {
      props: {
        label: 'name'
      },
      historyTableData: [],
      precheckListOption: [],
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        preCheckTree:[],
        visitRoute: ''
      },
      visitForm: {
        customerId: '',
        arrivalTime: '',
        deliveryContent: [],
        serviceContent: [],
        paymentReceive: [],
        notes: '',
        fileList: []
      },
      loading: false,
      dw: '60%',
      fileList: [],
      preCheckOption: [],
      precheckList: [],
      tableData: [],
      options: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      deliveryContentOptions: ['送店', '指送', '收退料', '放帳單'],
      serviceContentOptions: ['補目錄', '做宣傳', '交流'],
      paymentReceiveOptions: ['現金', '期票'],
      btnCount: 0,
      form: {
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        deliveryContentChecked: [],
        deliveryContent: '',
        serviceContentChecked: [],
        serviceContent: '',
        paymentReceiveChecked: [],
        paymentReceive: '',
        notes: '',
        fileList: [],
        fileNotes: []
      },
      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      visitRules: {
        preCheckTree:[{validator: treeCheck, trigger: 'change'}],
        visitRoute: [{validator: checkName, trigger: 'change'}]
      },
      visitFormRules: {
        custId: [{required: true, validator: checkName, trigger: 'change'}],
        arrivalTime: [{required: true, validator: checkName, trigger: 'change'}],
        customerRecord: [{required: true, validator: checkName, trigger: 'blur'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {

    loadCustomerHistoryData() {
      this.request.get("/todo/customer/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadCustomerHistoryData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleDraft() {
      let selectedIds = this.$refs.tree.getCheckedKeys();
      this.basicForm.preCheckItem = selectedIds.join(",")
      this.handleSubmitForm()
    },
    handleSign() {
      this.$refs['visitDataForm'].validate(async valid => {
        console.log('this.form:', valid)
        if (valid) {
          this.$confirm('送出簽核?', '提示', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            let selectedIds = this.$refs.tree.getCheckedKeys();
            this.basicForm.preCheckItem = selectedIds.join(",")
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    handleDelete(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 680; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = defaultWidth + "px";
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data

          if (res.data.preCheckItem !== '') {
            this.precheckListOption = res.data.preCheckItem.split(",")
          }
          // this.basicForm.title = res.data.title
          // this.basicForm.startDate = res.data.startDate
          // this.basicForm.endDate = res.data.endDate
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      this.form.todoType = this.getTodoType()
    },
    getTodoType() {
      this.userInfo.id;
    },
    loadPreCheckItem() {
      let req = '/dic/type?queryField=pre_check'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.preCheckOption = res.data
        }
      })
    },
    goBack() {
      this.$router.push('/daily/todo')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    saveCustomerVisit(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('valid:', valid)
        if (valid) {
          try {
            //將陣列轉換成後台可以接的字串
            this.form.deliveryContent = this.form.deliveryContentChecked.join(",")
            this.form.serviceContent = this.form.serviceContentChecked.join(",")
            this.form.paymentReceive = this.form.paymentReceiveChecked.join(",")
            this.request.post("/todo/customer/history", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false
                this.loadCustomerHistoryData()
                this.showResult('success', '新增成功')
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })

    },
    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    newUploadField() {
      this.btnCount++
    }
  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId

    //
    this.loadCustomerHistoryData()

    this.loadJobSignHistory()

    //設定一些欄位預設值
    this.formDefault()

    //出勤前檢查工作選項
    this.loadPreCheckItem()

    //撈我負責的客戶
    this.loadMyCustomer()


    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
